export default __webpack_public_path__ + "static/media/Roboto-Medium.7429a63c.ttf";